import { Button, Spinner } from "@nextui-org/react";
import { Download } from "lucide-react";
import FileUpload from "@/shared/components/custom/file-upload";
import { UploadedFile } from "@/shared/types/file-upload";
import { EvidenceDocument } from "../../requests";
import { doesFileHasError } from "@/shared/components/custom/file-upload/helper";

const DefaultAllowedFileTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/json",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "text/csv",
];

interface EvidenceDocumentCardProps {
  document: EvidenceDocument;
  files: UploadedFile[];
  onFilesChange: (documentId: string, files: UploadedFile[]) => void;
  onUploadError: (documentId: string, hasError: boolean) => void;
  isSaving?: boolean;
  customDeleteHandler?: (signedUrl: string, fileId: string) => Promise<void>;
}

const EvidenceDocumentCard: React.FC<EvidenceDocumentCardProps> = ({
  document,
  files,
  onFilesChange,
  onUploadError,
  isSaving = false,
  customDeleteHandler,
}) => {
  const handleFileChange = (newFiles: UploadedFile[]) => {
    const hasError = newFiles.some(file => doesFileHasError(file));
    onUploadError(document.id, hasError);
    onFilesChange(document.id, newFiles);
  };

  const handleDownloadSources = () => {
    if (document.source_urls && document.source_urls.length > 0) {
      document.source_urls.forEach((url, index) => {
        setTimeout(() => {
          const link = window.document.createElement('a');
          link.href = url;
          link.download = `${document.document_name}_source_${index + 1}`;
          link.click();
        }, index * 100);
      });
    }
  };

  return (
    <div className="bg-white  p-4 h-full">
      <div className="flex flex-col h-full">
        {/* Document Header */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <h3 className="text-sm font-medium text-gray-900">
                {document.document_name}
                {document.required && (
                  <span className="text-red-500 ml-1">*</span>
                )}
              </h3>
              
            </div>
            
          </div>

         
        </div>

        {/* File Upload Section */}
        <div className="flex-1">
          <FileUpload
            maxFiles={document.max_number_of_files}
            orientation="vertical"
            isMultiple={document.max_number_of_files > 1}
            allowedFileTypes={DefaultAllowedFileTypes}
            setFiles={handleFileChange}
            maxSizeMB={20}
            initialFiles={files}
            customDeleteHandler={customDeleteHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default EvidenceDocumentCard;